export default "__VITE_ASSET__B89YOW5k__"